module.exports = __webpack_public_path__ + "static/media/Project-Scope-Img.0a245de2.png";